import React from 'react';
import {Input} from "@/components/ui/input";
import {StaticWordEnum} from "@/constants/general-enum";

interface OtpInputProps {
    register: any;
    onComplete?: (otp: string) => void;
    customClass?: string;
}

function OtpInput({customClass = " ", register, onComplete}: OtpInputProps) {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (value.length === 5) {
            if (onComplete) {
                onComplete(value);
            }
        }
    };

    return (
        <Input
            inputMode={"numeric"}
            autoFocus={true}
            autoComplete={"one-time-code"}
            {...register("otp", {required: true})}
            onChange={handleChange}
            maxLength={5}
            className={`h-[54px] md:h-[64px] rounded-2xl text-center placeholder:text-start placeholder:font-medium ${customClass}`}
            placeholder={StaticWordEnum.getCode}
        />
    );
}

export default OtpInput;